import { Link } from 'react-router-dom';
import Header from '../../sharedScreen/Header'
import Footer from 'screens/sharedScreen/Footer';
import MembershipForm from './MembershipForm';
import Carousel from 'react-multi-carousel';
import SocialMediaIcon from 'screens/sharedScreen/SocialMediaIcon';
import { JoinUs } from '../join-us/JoinUs';
import Testimonial from '../testimonial/Testimonial';

const MembershipBenifits = () => {


    return (
        <div className='meberbership-benifit-sec'>
            {/* <div className="page-wrapper"> */}

            {/* <!--Page Header Start--> */}
            <section className="page-header h-auto mebership-benifit member-section">
                <img src="/images/banner/membership-benifits.jpg"></img>
                <div className="page-header__bg membersship-banner">
                </div>
                    <div className="page-header__inner">
                        <h2 className='benefit-color d-flex justify-content-center'>Membership Benefits</h2>
                        <div className="thm-breadcrumb__box">
                         
                        </div>
                    </div>
                 
            </section>
           
            <section className="process-one">
                <div className="container">
                    <div className="section-title text-center">
                        <div className="border-center section-title__tagline-box">
                            <span className="section-title__tagline">Benefits of joining <span class="one--">1</span><span class="wn">WN</span> </span>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-4 col-lg-4 process-one-- wow fadeInUp" data-wow-delay="100ms">
                            <div className="process-one__single">
                                <div className="process-one__shape-1">
                                    <img src="/images/member/membership-benifit/global-networking.jpg" alt=""></img>
                                </div>
                                <div className="process-one__count"></div>
                                <div className="process-one__icon-and-text">
                                    <h6>Exclusive Global Network</h6>
                                    <p>
                                        Connecting logistics professionals worldwide, ensuring maximum opportunities and minimal competition.
                                      
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 process-one-- wow fadeInUp" data-wow-delay="200ms">
                            <div className="process-one__single">
                                <div className="process-one__shape-1">
                                    <img src="images/member/membership-benifit/tailored-freight.jpg" alt=""></img>
                                </div>
                                <div className="process-one__count"></div>
                                <div className="process-one__icon-and-text">
                                    <h6>Tailored Freight Solutions</h6>
                                    <p>Streamlined operations for enhanced efficiency in freight management.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 process-one-- wow fadeInUp" data-wow-delay="300ms">
                            <div className="process-one__single">
                                <div className="process-one__shape-1">
                                    <img src="images/member/membership-benifit/freight.png" alt=""></img>
                                </div>
                                <div className="process-one__count"></div>
                                <div className="process-one__icon-and-text">
                                    <h6>Real-Time Freight Quotes & Tracking</h6>
                                    <p>Enabling smooth international logistics with instant updates.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 process-one-- wow fadeInUp" data-wow-delay="300ms">
                            <div className="process-one__single">
                                <div className="process-one__shape-1">
                                    <img src="images/member/membership-benifit/financial-protection.jpg" alt=""></img>
                                </div>
                                <div className="process-one__count"></div>
                                <div className="process-one__icon-and-text">
                                    <h6>Comprehensive Financial Protection</h6>
                                    <p>Secure transactions and peace of mind when working with network members.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 process-one-- wow fadeInUp" data-wow-delay="300ms">
                            <div className="process-one__single">
                                <div className="process-one__shape-1">
                                    <img src="images/member/membership-benifit/global-trade.jpg" alt=""></img>
                                </div>
                                <div className="process-one__count"></div>
                                <div className="process-one__icon-and-text">
                                    <h6>Global Trade Opportunities</h6>
                                    <p>Driving business growth and expanding trade across regions.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 process-one-- wow fadeInUp" data-wow-delay="300ms">
                            <div className="process-one__single">
                                <div className="process-one__shape-1">
                                    <img src="images/member/membership-benifit/industry-leading.jpg" alt=""></img>
                                </div>
                                <div className="process-one__count"></div>
                                <div className="process-one__icon-and-text">
                                    <h6>Industry-Leading Conferences & Networking</h6>
                                    <p>High-profile events designed to foster valuable logistics connections.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 process-one-- wow fadeInUp" data-wow-delay="300ms">
                            <div className="process-one__single">
                                <div className="process-one__shape-1">
                                    <img src="images/member/membership-benifit/24_7.jpg" alt=""></img>
                                </div>
                                <div className="process-one__count"></div>
                                <div className="process-one__icon-and-text">
                                    <h6>24/7 Multilingual Support</h6>
                                    <p>Offering personal guidance and assistance anytime, anywhere.</p>
                                </div>
                            </div>
                        </div>
                        {/* <div className="col-xl-4 col-lg-4 process-one-- wow fadeInUp" data-wow-delay="300ms">
                            <div className="process-one__single">
                                <div className="process-one__shape-1">
                                    <img src="images/member/membership-benifit/ai.jpg" alt=""></img>
                                </div>
                                <div className="process-one__count"></div>
                                <div className="process-one__icon-and-text">
                                    <h6>AI-Enhanced Member Platform</h6>
                                    <p>Optimize international shipping and communication for seamless workflows.</p>
                                </div>
                            </div>
                        </div> */}
                        <div className="col-xl-4 col-lg-4 process-one-- wow fadeInUp" data-wow-delay="300ms">
                            <div className="process-one__single">
                                <div className="process-one__shape-1">
                                    <img src="images/member/membership-benifit/global-reach.jpg" alt=""></img>
                                </div>
                                <div className="process-one__count"></div>
                                <div className="process-one__icon-and-text">
                                    <h6>Global Reach, Local Expertise</h6>
                                    <p>Addressing business needs across the globe with localized knowledge.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 process-one-- wow fadeInUp" data-wow-delay="300ms">
                            <div className="process-one__single">
                                <div className="process-one__shape-1">
                                    <img src="images/member/membership-benifit/collaborative-logistics.jpg" alt=""></img>
                                </div>
                                <div className="process-one__count"></div>
                                <div className="process-one__icon-and-text">
                                    <h6>Collaborative Logistics Community</h6>
                                    <p>Encouraging collaboration, innovation, and growth among members.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

 <Testimonial />
            <JoinUs />

        </div>





    )
}

export default MembershipBenifits